/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v3.0.0 (Bootstrap 5.3)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2023 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import { createApp } from "vue";
import * as Sentry from "@sentry/vue";
import axios from "axios";
import store from "./vuex/store"; // vuex store instance

import 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import App from "./App.vue";
import Cookies from "js-cookie";
// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";

window.axios = axios;
// router setup
import router from "./routes/routes";

// import "./registerServiceWorker"; // Comentado temporalmente - solo necesario en producción

import "sweetalert2/src/sweetalert2.scss";

import swal from 'sweetalert2';
window.Swal = swal;

window.Moment = require("moment");
window.Moment.locale("es");

import VueApexCharts from 'vue3-apexcharts';
import { Icon } from '@iconify/vue';

// FontAwesome Icons - Vue 3 compatible
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faHome,
  faFileContract,
  faMedal,
  faMoneyBillWave,
  faMoneyBill,
  faArchive,
  faBoxOpen,
  faBoxes,
  faFolderOpen,
  faFolder,
  faIdCard,
  faCopy,
  faUsers,
  faFutbol,
  faUsersCog,
  faUser,
  faUserCheck,
  faUserGraduate,
  faUserTie,
  faCreditCard,
  faFileAlt,
  faFileDownload,
  faFileArchive,
  faBell,
  faSearch,
  faEye,
  faEyeSlash,
  faTrash,
  faMinusSquare,
  faCheckSquare,
  faEdit,
  faPen,
  faEnvelope,
  faCloudUploadAlt,
  faTools,
  faQuestion,
  faBars,
  faHandPointer,
  faThumbsDown,
  faThumbsUp,
  faClipboardList,
  faCog,
  faSave,
  faAngleLeft,
  faAngleRight,
  faSchool,
  faBuilding,
  faPlus,
  faDownload,
  faPaperPlane,
  faSync,
  faKey,
  faChevronDown,
  faPlayCircle,
  faPaperclip,
  faPhotoVideo,
  faNewspaper,
  faCalendar,
  faSignInAlt,
  faClock,
  faCheck,
  faCheckCircle,
  faTimes,
  faComments,
  faFilePdf,
  faMicrophone,
  faGolfBall,
  faImage,
  faArrowRight,
  faDollarSign
} from '@fortawesome/free-solid-svg-icons';

// Add icons to library
library.add(
  faHome, faFileContract, faMedal, faMoneyBillWave, faMoneyBill,
  faArchive, faBoxOpen, faBoxes, faFolderOpen, faFolder, faIdCard,
  faCopy, faUsers, faFutbol, faUsersCog, faUser, faUserCheck,
  faUserGraduate, faUserTie, faCreditCard, faFileAlt, faFileDownload,
  faFileArchive, faBell, faSearch, faEye, faEyeSlash, faTrash,
  faMinusSquare, faCheckSquare, faEdit, faPen, faEnvelope,
  faCloudUploadAlt, faTools, faQuestion, faBars, faHandPointer,
  faThumbsDown, faThumbsUp, faClipboardList, faCog, faSave,
  faAngleLeft, faAngleRight, faSchool, faBuilding, faPlus,
  faDownload, faPaperPlane, faSync, faKey, faChevronDown,
  faPlayCircle, faPaperclip, faPhotoVideo, faNewspaper, faCalendar,
  faSignInAlt, faClock, faCheck, faCheckCircle, faTimes, faComments,
  faFilePdf, faMicrophone, faGolfBall, faImage, faArrowRight, faDollarSign
);

axios.interceptors.request.use(
  function (config) {
    config["headers"] = {
      Authorization: "Bearer " + Cookies.get("access_token"),
      tokentap: 'Sb7qmGAxCrqdZz370F5cGSNrcQNidjQ2',
      Accept: "application/json"
    };
    config["onUploadProgress"] = progressEvent => {
      /* store.dispatch(
         "update_upload_percentage",
         Math.round((progressEvent.loaded * 100) / progressEvent.total)
       );*/
    };

    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // Clear cookies
      const cookies = Cookies.get();
      for (const cookie in cookies) {
        Cookies.remove(cookie);
      }
      
      swal.fire({
        title: "Sesión vencida",
        text: "Tu sesión ha expirado. Por favor, inicia sesión nuevamente.",
        icon: "warning",
        confirmButtonColor: "#B49B57",
      }).then(() => {
        router.push("/login");
      });
    }
    return Promise.reject(error);
  }
);

import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;

import * as Config from "./config";

// LOGOUT POR INACTIVIDAD
import InactivityLogout from './inactivity_logout.js';

// Create Vue app
const app = createApp(App);

Sentry.init({
  app,
  dsn: "https://064507c8eea46b77bd3f51dcc9ecdc59@o4511332547035136.ingest.us.sentry.io/4511481019564032",
  sendDefaultPii: true,
  beforeSend(event, hint) {
    // Solo enviar si es un error (excepción) o si el nivel es error/fatal, ignorando warnings y logs informativos
    if (event.level && event.level !== 'error' && event.level !== 'fatal') {
      return null;
    }
    return event;
  }
});

// Use plugins
app.use(router);
app.use(store);
app.use(LightBootstrap);
app.use(VueApexCharts);

// Add global mixin for inactivity logout
app.mixin(InactivityLogout);

// Register FontAwesome component globally
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('v-icon', FontAwesomeIcon);
app.component('iconify-icon', Icon);

// Mount app
app.mount("#app");
